/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Keen_Eagle_SoarInputs */

const en_deep_keen_eagle_soar = /** @type {(inputs: Deep_Keen_Eagle_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strong`)
};

const de_deep_keen_eagle_soar = /** @type {(inputs: Deep_Keen_Eagle_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stark`)
};

/**
* | output |
* | --- |
* | "Strong" |
*
* @param {Deep_Keen_Eagle_SoarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const deep_keen_eagle_soar = /** @type {((inputs?: Deep_Keen_Eagle_SoarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Keen_Eagle_SoarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deep_keen_eagle_soar(inputs)
	return de_deep_keen_eagle_soar(inputs)
});